import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import Carousel from "antd/lib/carousel";

import styles from "./styles/SimilarAdsSection.scss";
import { getSimilarAds, selectSimilarAds } from "../../../routes/Ad/ad.ducks";
import { isMediumScreen } from "../../../services";
import { SimilarAdCard } from "../../../components/SimilarAdCard";
import getWidthContext from "../../../HOCs/getWidthContext";
import ReactGA from "react-ga4";
import { selectCategories } from "../../App/selectors";
import useHrPageName from "../../../utils/useHrPageName";

const defaultResponsiveSettings = [
  {
    breakpoint: 1900,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
  {
    breakpoint: 1600,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4
    }
  },
  {
    breakpoint: 1400,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
  {
    breakpoint: 1000,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  },
  {
    breakpoint: 700,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
];

let mousePressTimer: any;
const SimilarAdsQuantity = 16;
const similarAdsCarouselClassName = "similarAdsCarousel";

function SimilarAdsSection(props: any) {
  const {
    adId,
    favoriteIds,
    getSimilarAds,
    similarAds,
    responsiveSettings,
    width,
    category,
    categories,
    setLoadingSimilar,
    hasFavorite,
    module,
  } = props;
  const [dragging, setDragging] = useState(false);
  const hrPageName = useHrPageName(category);

  useEffect(() => {
    setLoadingSimilar(true);
    getSimilarAds(
      adId,
      favoriteIds,
      SimilarAdsQuantity,
      () => setLoadingSimilar(false),
      module,
      category
    );
  }, [
    favoriteIds,
    JSON.stringify(similarAds) != JSON.stringify([])
  ]);

  useEffect(() => {
    window.addEventListener("mouseup", handleMouseRelease, false);

    return () => {
      window.removeEventListener("mouseup", handleMouseRelease, true);
    };
  }, [adId, favoriteIds]);

  const handleMousePress = () => {
    clearTimeout(mousePressTimer);
    mousePressTimer = setTimeout(() => !dragging && setDragging(true), 150);
  };

  const handleMouseRelease = () => {
    clearTimeout(mousePressTimer);
    setTimeout(() => dragging && setDragging(false), 500);
  };

  const sendGoogleEvent = (e) => {
    if (dragging) return e.preventDefault();
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `Odabir sličnih oglasa - ${hrPageName}`
    });
  };

  const focusAd = () => {
    const item = document.querySelectorAll(`.${similarAdsCarouselClassName}`);
    if (item && item.length > 0) {
      // @ts-ignore
      item[0].focus({ preventScroll: true });
      // @ts-ignore
      item[0].click();
    }
    const a = document.querySelectorAll(`.${similarAdsCarouselClassName} > div > div > .slick-current > div > a`);
    if (a && a.length > 0) {
      // @ts-ignore
      a[0].focus({ preventScroll: true });
    }
  };

  const slides = useMemo(() => similarAds.map((ad: any) => (
      <SimilarAdCard
        hasFavorite={hasFavorite !== undefined ? hasFavorite : true}
        onMouseDown={handleMousePress}
        onMouseUp={handleMouseRelease}
        key={ad.id}
        className={styles.adCard}
        onClick={sendGoogleEvent}
        ad={ad}
        adLists={{ similar: { data: [ad] } }}
        category={category}
        flag="SimilarAdsSection"
        eventLabel={`Similar Ads - Gallery swipe`}
      />
  )), [
    similarAds,
    category,
    categories,
    handleMousePress,
    handleMouseRelease
  ]);
  
  if (similarAds.length < 1) {
    return null;
  }

  const mobile = isMediumScreen(width);

  return (
    <div className={styles.container}>
      <div className={styles.title}>{"Slični oglasi"}</div>
      <Carousel
        swipe
        draggable
        slidesToShow={4}
        slidesToScroll={4}
        infinite={false}
        // @ts-ignore
        customPaging={() => (
          <div className={!mobile ? styles.dot : styles.dotMobile} />
        )}
        dots
        className={`${styles.carousel} ${similarAdsCarouselClassName}`}
        responsive={responsiveSettings}
        afterChange={focusAd}
      >
        {slides}
      </Carousel>
    </div>
  );
}

SimilarAdsSection.defaultProps = {
  responsiveSettings: defaultResponsiveSettings
};

export default connect(
  state => ({
    similarAds: selectSimilarAds(state),
    categories: selectCategories(state)
  }),
  {
    getSimilarAds
  }
)(getWidthContext(SimilarAdsSection));



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/SimilarAdsSection.tsx